const convertTimestampToDate = (timestamp: string) => {
  const date = new Date(timestamp);

  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear();

  return `${month}/${day}/${year}`;
};

export default convertTimestampToDate;
